var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegresarBalken1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.12 18.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#EFB928;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.12 7.56 5.74 7.56 11.18 2.12 9.06 0 0 9.06 9.06 18.12 11.18 16 5.74 10.56 20.12 10.56 20.12 7.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegresarBalken1);
export default __webpack_public_path__ + "static/media/regresar_BALKEN_1.8d8ed85a24cb4cc38db9d9292a9cc3f3.svg";
export { ForwardRef as ReactComponent };